export default __webpack_public_path__ + "static/media/4.df161a78.jpg";